import { useEffect, useState } from 'react';
import { subscribeDonationRecords } from '../utils/donationRecords';

// Campaign history is shared by the total and viewer subtotal; no second wallet query.
export function useDonationRecords({ spaceOwnerUid, componentId, currency, tokenMint, recipient, cluster }) {
    const scope = JSON.stringify([spaceOwnerUid, componentId, currency, tokenMint, recipient, cluster]);
    const [state, setState] = useState({ scope: '', records: [] });
    useEffect(() => {
        if (!spaceOwnerUid || !componentId) return undefined;
        let active = true;
        const stop = subscribeDonationRecords({ spaceOwnerUid, componentId, currency, tokenMint, recipient, cluster },
            records => { if (active) setState({ scope, records }); },
            error => console.error('Donation history could not be loaded:', error.code || error.name));
        return () => { active = false; stop(); };
    }, [spaceOwnerUid, componentId, currency, tokenMint, recipient, cluster, scope]);
    return state.scope === scope ? state.records : [];
}
